export enum ReservationEvent {
  COMPLETE_HOSPITALADMIN_CONFIRM = 'complete_hospitaladmin_confirm',
  COMPLETE_HOSPITALADMIN_VISIT = 'complete_hospitaladmin_visit',
}

export type EventType = ReservationEvent;
